import React from 'react';
import Modal from '../../../shared/components/ui/Modal';
import Button from '../../../shared/components/ui/Button';

interface ProcessHighlightModalProps {
  isOpen: boolean;
  highlightName: string;
  isProcessing: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ProcessHighlightModal: React.FC<ProcessHighlightModalProps> = ({
  isOpen,
  highlightName,
  isProcessing,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Send highlight for processing" className="max-w-md">
      <div className="p-6 space-y-4 text-sm text-gray-700">
        <p>
          You are about to send <span className="font-semibold">{highlightName}</span> for backend processing.
        </p>
        <p>
          The clips in this highlight will be stitched into a single video by the workers. This may take a few minutes
          depending on video length. You can continue working while processing runs in the background.
        </p>
        <p className="text-xs text-gray-500">
          Once queued, the status will change to <span className="font-medium">Queued</span> /{' '}
          <span className="font-medium">Processing</span>. When it is ready you will see a download option.
        </p>

        <div className="flex justify-end space-x-3 pt-2">
          <Button type="button" variant="ghost" onClick={onClose} disabled={isProcessing}>
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={onConfirm} disabled={isProcessing}>
            {isProcessing ? 'Sending…' : 'Send for processing'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ProcessHighlightModal;